$(document).on('click', '.js-download-desktop-app', function () {
    let version = $(this).data('version');
    $.ajax({
        url: '/local/ajax/desktopAppStatistics.php',
        method: 'POST',
        data: {
            'version': version,
            'action': 'download'
        }
    });
});